import React, { Fragment } from "react";
import { IconButton } from "@material-ui/core";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
export const SearchDialogSimplePager = ({ isLoading, apiResponse, setRequestedPage, }) => {
    return (React.createElement(Fragment, null,
        isLoading && (React.createElement("span", { style: { color: "#aaaaaa" } }, "Loading, please wait...")),
        !isLoading && apiResponse.data.length && (React.createElement(Fragment, null, apiResponse.page !== undefined && apiResponse.totalCount !== 0 && (React.createElement(Fragment, null,
            "Page ",
            apiResponse.page + 1)))),
        React.createElement(IconButton, { onClick: () => setRequestedPage(apiResponse.page - 1), disabled: isLoading || apiResponse.page === 0 },
            React.createElement(ChevronLeft, null)),
        React.createElement(IconButton, { onClick: () => setRequestedPage(apiResponse.page + 1), disabled: !apiResponse.hasNextPage },
            React.createElement(ChevronRight, null))));
};
